export default {
  namespaced: true,

  state: () => ({
    affiliator: {},
    isLoading: false,
  }),

  getters: {},

  mutations: {
    SET_AFFILIATOR(state, payload) {
      state.affiliator = payload
    },
    SET_LOADING(state, payload) {
      state.isLoading = payload
    },
  },

  actions: {
    // show
    async getAffiliator({ commit }, { id }) {
      try {
        commit('SET_LOADING', true)
        const url = `/v1/admin/affiliators/${id}`

        const response = await this._vm.$http.get(url)

        commit('SET_AFFILIATOR', response.data)
        commit('SET_LOADING', false)

        return response.data
      } catch (error) {
        commit('SET_LOADING', false)
        return error
      }
    },
    // delete
    async deleteAffiliator({ commit }, { userId }) {
      try {
        const url = `/v1/admin/product-affiliates/${userId}`

        const response = await this._vm.$http.delete(url)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menghapus Affiliator!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menghapus Affiliator!',
        }, { root: true })

        return error
      }
    },
    // create
    async createAffiliator({ commit }, data) {
      try {
        const url = '/v1/admin/product-affiliates'

        const response = await this._vm.$http.post(url, data)

        commit('response/SET_SUCCESS', {
          message: 'Berhasil Menambahkan Affiliator!',
        }, { root: true })

        return response.data
      } catch (error) {
        commit('response/SET_ERROR', {
          message: 'Gagal Menambahkan Affiliator!',
        }, { root: true })

        return error
      }
    },
  },
}
